namespace GeniuzPOS.ReportMasterData {
    export class Report_1414Columns {
        static columnsKey = 'ReportMasterData.Report_1414';
    }
}
